// @flow

import { httpPost } from '../helpers/helpers.api';

export function createLinkToBridge() {
    return httpPost('philips-hue/create');
}

export function pairWithBridge(id: string) {
    return httpPost(`philips-hue/pair/${id}`);
}

export function searchForBridgeAgain(id: string) {
    return httpPost(`philips-hue/search/${id}`);
}



// WEBPACK FOOTER //
// ./src/core/api/install-hue-bridge/index.js